import React from 'react';
import {DocumentUtils} from "../../../Utils";
import {service as StreamBankAuthService} from "../../../Services/StreamBankAuthService";
import {useLogoutRedirect} from "../../../Hooks/LoginHooks";

export const LogoutPage = (props) => {
    const message = DocumentUtils.GetQueryStringParameter("message");
    const redirectUrl = DocumentUtils.GetQueryStringParameter("redirectUrl");
    
    useLogoutRedirect(redirectUrl ?? `/login${message ? `?message=${message}` : ''}`);
    void StreamBankAuthService.Logout();
    return null;
};


